import { put, select, spawn, delay } from "redux-saga/effects";
import { IScreenLockerState, screenLockerAT } from "./ScreenLockerModel";
import { uuid6 } from "../../../../../common/utils/utils";
import { screenLockerSelector } from "./screenLockerDomain";

export function* lockScreenSaga() {
    const lockGuid = uuid6();

    yield put({
        type: screenLockerAT.lock,
        lockGuid,
        lockTime: Date.now(),
    });

    return lockGuid;
}

export function* unLockScreenSaga(lockGuid: string) {
    const { lockedOn, locks }: IScreenLockerState = yield select(
        screenLockerSelector
    );
    if (!lockedOn)
        return console.warn("Unlock not locked state with key: " + lockGuid);

    if (!locks.includes(lockGuid))
        return console.warn("Unlock not locked guid: " + lockGuid);

    const diff = Date.now() - lockedOn;
    if (diff > 1500) {
        yield put({
            type: screenLockerAT.unlock,
            lockGuid,
        });
    } else {
        yield spawn(unLockScreenLaterSaga, diff, lockGuid);
    }
}

function* unLockScreenLaterSaga(timeout: number, lockGuid: string) {
    yield delay(timeout);

    yield put({
        type: screenLockerAT.unlock,
        lockGuid,
    });
}
